import React from 'react';
import confirm from '../../utils/confirm';
import Content from '../dashboard/Content';
import Dialog from '../../toolkit/dialog';
import templateService from '../../services/template-service';
import CreateTemplateDialog from './CreateTemplateDialog';
import { Card } from '../widgets';
import { Link } from 'react-router-dom';

import './style';

export default class Template extends React.Component {

  state = {
    templates: []
  }

  render() {
    const templates = this.state.templates;
    return (
      <Content title="لیست الگوها">
        <div className="d-flex templates-component flex-column">
          <div className="template-header">
            <button className="btn btn-success btn-add-template" onClick={this.handleButtonAddClick}>
              <span className="ml-2"><i className="far fa-plus"></i></span>
              <span>افزودن الگو</span>
            </button>
          </div>
          <hr style={{ width: '100%' }} />
          <div className="row d-flex">
            {templates.map(t => (
              <div className="col-xxl-2 col-3" key={t._id}>
                <Card style={{ paddingBottom: '0.35rem' }}>
                  <div className="template-item">
                    <i className="far fa-cog mb-1"></i>
                    {t.name}
                  </div>
                  <hr style={{ width: '100%', margin: '0.5rem 0' }} />
                  <div className="row template-footer">
                    <div className="col text-center">
                      <Link className="ant-btn" to={'/dashboard/templates/' + t._id}>ویرایش</Link>
                    </div>
                    <div className="col text-center">
                      <button
                        className="ant-btn danger"
                        onClick={this.handleRemoveClick.bind(this, t._id)}>حذف</button>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </Content>
    );
  }

  public componentDidMount = async () => {
    const templates = await templateService.fetch();
    this.setState({ templates });
  }

  private handleButtonAddClick = () => {
    new Dialog({
      rtl: true,
      size: 'small',
      title: 'ایجاد الگوی جدید',
      message: CreateTemplateDialog,
      onClose: this.componentDidMount
    }).show();
  }

  private handleRemoveClick = (id: string) => {
    confirm({
      type: 'alert',
      size: 'small',
      title: 'آیا میخواهید این الگو را حذف کنید؟',
      primaryClass: 'ant-btn-danger',
      onSubmit: async () => {
        await templateService.remove(id);
        this.componentDidMount();
      }
    }).show();
  }

}
